import { render, staticRenderFns } from "./DPH26.vue?vue&type=template&id=6cba11e0"
import script from "./DPH26.vue?vue&type=script&lang=js"
export * from "./DPH26.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports